import { render, staticRenderFns } from "./AddParamGroupBarWidget.vue?vue&type=template&id=56f78a9b"
import script from "./AddParamGroupBarWidget.vue?vue&type=script&lang=js"
export * from "./AddParamGroupBarWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports